/**
 * Instagram story HTTPS URL’sini mobilde öncelikle uygulamada açmayı dener.
 * - Android: intent:// + com.instagram.android (yüklüyse uygulama, değilse tarayıcı fallback)
 * - iOS: https universal link; programatik <a> tıklaması Safari’de uygulamaya yönlendirmeyi kolaylaştırır
 * - Masaüstü: yeni sekmede web
 */
export function openInstagramStorySmart(webUrl: string): void {
  if (typeof window === 'undefined' || !webUrl) return;

  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);

  if (isAndroid) {
    try {
      const u = new URL(webUrl);
      if (!u.hostname.toLowerCase().includes('instagram.com')) {
        window.open(webUrl, '_blank', 'noopener,noreferrer');
        return;
      }
      const path = `${u.pathname}${u.search}${u.hash}`;
      const intent = `intent://www.instagram.com${path}#Intent;scheme=https;package=com.instagram.android;S.browser_fallback_url=${encodeURIComponent(webUrl)};end`;
      window.location.assign(intent);
      return;
    } catch {
      window.open(webUrl, '_blank', 'noopener,noreferrer');
      return;
    }
  }

  if (isIOS) {
    const a = document.createElement('a');
    a.href = webUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  }

  window.open(webUrl, '_blank', 'noopener,noreferrer');
}
